import moment from 'moment';

const getYears = (date) => {
    if (!date || date === '0000-00-00') {
      return '--';
    }
    let result = moment().diff(date, 'years');
    if (typeof result !== 'number' || isNaN(result) || result < 0) {
      return '--';
    }
    if (result < 1) {
      result = moment().diff(date, 'months');
      if (result == 1) {
        return result + ' mes';
      }
      return result + ' meses';
    } 
    if (result == 1) {
      return result + ' año';
    }
    return result + ' años';    
  }

  export default getYears;